<!--- Formulario Paletizado con Lectura de cajas ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el formulario:
-----------------------
-

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page class="main-frm-box-reading">
    <template #fixed>
      <TheNavbar
        :nav-title="$t('RegProdTrab')"
        :back-btn-enable="true"
        :back-callback="CerrarFrm"
        :style="appTheme"
      >
        <template #right>
          <div
            class="display-flex"
          >
            <f7-link @click="popupConfigurationRegisterBoxes = true">
              <img :src="settings">
            </f7-link>
          </div>
        </template>
      </TheNavbar>
    </template>
    <PCLectorPaleAndElaborateArticles
      ref="componentPCLectorPaleAndElaborateArticles"
      :continuous-bar-code-reading="true"
      @code-reading-elaborated-article="eventReadElaboratedArticle"
      @code-reading-palet="eventReadPalet"
      @update-front="update"
    />

    <!-- CONTAINER INFO PALE -->
    <div
      v-if="objAnsSelected != null"
      class="container-pale"
    >
      <div class="container-pale__title">
        <div>
          <span class="span-texto-azulOscuro-22-500">{{ objAnsSelected.NumeroSerie }}</span>
        </div>
        <div class="display-flex align-items-center">
          <span class="span-texto-grisAzul-22-400">
            {{ `${lstElaborateArticles.length} / ${numeroEnvasesAnsSeleccionada}` }}
          </span>
          <img
            class="margin-left-half"
            data-v-ef59f0c6=""
            alt="iconBox"
            src="@/static/icons/ic_box.svg"
          >
        </div>
      </div>
      <div class="content-subtitle">
        <div>
          <span class="span-texto-grisAzul-14-400">{{ productoAnsSeleccionada.Nombre }}</span>
        </div>
        <div>
          <span class="span-texto-gris-14-500">{{ envaseAnsSeleccionada.Nombre }}</span>
        </div>
        <div class="content-subtitle__strong">
          <span>{{ partsANS }}</span>
        </div>
      </div>
    </div>

    <!-- CONTAINER INFO CAJAS -->
    <div class="container-elaborated-items">
      <div
        v-if="objAnsSelected != null"
        class="container-elaborated-items__title"
      >
        <span>   {{ $t('CajasAsociadasAlPale') }}  </span>
      </div>
      <div class="container-elaborated-items__list">
        <UCPreload :show="preloader" />
        <div
          v-if="!preloader"
        >
          <div
            v-for="articleElaborated in lstElaborateArticles"
            :key="articleElaborated.Id"
            class="container-elaborated-items__item"
          >
            <div class="content-subtitle">
              <div>
                <span
                  class="span-texto-azulOscuro-22-500"
                >{{ articleElaborated.IdUnicoCodigoBarras }}</span>
              </div>
              <div class="content-subtitle__gray">
                <span
                  v-if="articleElaborated.Producto != null"
                  class="span-texto-grisAzul-14-400"
                >{{ articleElaborated.Producto.Nombre }}</span>
              </div>
              <div class="content-subtitle__strong">
                <span>{{ (getPartsArticleElaborated(articleElaborated)) }}</span>
              </div>
              <div
                v-if="mostrarTrabajadores"
                class="content-subtitle__gray"
              >
                <span>{{ (getWorkersArticleElaborated(articleElaborated)) }}</span>
              </div>
            </div>
            <div
              class="btn-base-rojo-1 seleccionable"
              @click="requestDeleteElaboratedArticle(articleElaborated)"
            >
              <img
                src="@/static/icons/ic_trash_white.svg"
                alt="iconDelete"
                width="14px"
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Configuración del formulario registro de cajas -->
    <f7-popup
      class="popup-ConfiguracionRegistroCajas"
      :opened="popupConfigurationRegisterBoxes"
      @popup:closed="popupConfigurationRegisterBoxes = false"
    >
      <f7-navbar
        :title="$t('common.configuration')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupConfigurationRegisterBoxes = false">
            {{ $t('common.x') }}
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div>
        <!-- Cabecera Formulario -->
        <div class="div-configuracionRegistroCajas-cabeceraFormulario">
          <f7-block-title> Opción Trabajadores </f7-block-title>
          <f7-block>
            <f7-list>
              <f7-list-item>
                <span class="span-texto-grisAzul-14-400"> Mostrar Trabajadores </span>
                <f7-toggle
                  :checked="mostrarTrabajadores"
                  @change="mostrarTrabajadores = !mostrarTrabajadores"
                />
              </f7-list-item>
            </f7-list>
          </f7-block>
        </div>
      </div>
    </f7-popup>
    <!-- Action Confirmación Eliminar Palé -->
    <UCConfirmation ref="componentConfirmationDeletePale" />
  </f7-page>
</template>

<script>
import { mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import TheNavbar from '@/components/TheNavbar.vue';
import { f7 } from 'framework7-vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import PCLectorPaleAndElaborateArticles from '@/components/production/traceability/PCLectorPaleAndElaborateArticles.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import settings from '@/static/img/ic_setting.svg';
import { callExecuteSPERP } from '@/js/services/APIErp';
import { notifyReadingError } from '@/js/utils/notifyReadingError';

export default {
  name: 'FrmBoxReadingsPalletizing',
  components: {
    TheNavbar,
    PCLectorPaleAndElaborateArticles,
    UCConfirmation,
    UCPreload,
  },

  data() {
    return {
      objAnsSelected: null,
      preloader: false,
      lstElaborateArticles: [],
      partsANS: '',
      settings,
      popupConfigurationRegisterBoxes: false,
    };
  },
  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-steel-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },
    ...mapWritableState(useTraceabilityStore, [
      'mostrarTrabajadores',
    ]),

    productoAnsSeleccionada() {
      if (this.objAnsSelected != null && this.objAnsSelected.Existencias.length > 0) {
        return this.objAnsSelected.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Producto')[0].Articulo;
      }
      return null;
    },
    numeroEnvasesAnsSeleccionada() {
      if (this.objAnsSelected != null && this.objAnsSelected.Existencias.length > 0) {
        return this.objAnsSelected.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Envase')[0].Cantidad;
      }
      return null;
    },
    envaseAnsSeleccionada() {
      if (this.objAnsSelected != null && this.objAnsSelected.Existencias.length > 0) {
        return this.objAnsSelected.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Envase')[0].Articulo;
      }
      return null;
    },
  },

  methods: {
    RestablecerFrm() {
      this.objAnsSelected = null;
      this.lstElaborateArticles = [];
    },
    /** * Método CerrarFrm */
    CerrarFrm() {
      Log(this, this.CerrarFrm.name);
      f7.views.main.router.back();
      window.screen.orientation.unlock();
    },
    requestDeleteElaboratedArticle(objArticle) {
      Log(this, this.requestDeleteElaboratedArticle.name);
      this.$refs.componentConfirmationDeletePale.create(
        'Eliminar Articulo Elaborado',
        'Esta acción eliminara el articulo elaborado del palé. ¿Deseas continuar con la acción?',
        () => {
          this.dataeleteElaboratedArticle(objArticle);
        },
      );
      this.$refs.componentConfirmationDeletePale.show();
    },
    async dataeleteElaboratedArticle(objArticle) {
      Log(this, this.dataeleteElaboratedArticle.name);
      this.preloader = true;
      this.lstElaborateArticles = [];
      await this.Conexion_RemoveAssociationArticleElaboratedWithPale(objArticle.CodigoBarras);
      this.lstElaborateArticles = await this.Conexion_ObtainElaboratedArticlesXSerialNumber(this.objAnsSelected);
      this.preloader = false;
    },
    async establishedPallet(objAns) {
      Log(this, this.establishedPallet.name);
      this.preloader = true;
      this.objAnsSelected = objAns;
      this.$refs.componentPCLectorPaleAndElaborateArticles.changeInputToElaboratedArticle();
      this.partsANS = await this.getPartsANS(objAns.Id);
      this.lstElaborateArticles = await this.Conexion_ObtainElaboratedArticlesXSerialNumber(this.objAnsSelected);
      this.preloader = false;
    },
    eventReadPalet(value) {
      Log(this, this.eventReadPalet.name);

      const preloaderText = this.$t('codeScanner.info.validatingSerialNumber');
      HiDialog.Preloader(true, preloaderText);

      this.RestablecerFrm();
      ConexionTA.callObtenePalePorNumeroDeSerie(value, true, true).then((result) => {
        if (result.Valor) {
          const palet = JSON.parse(result.Mensaje);
          if (palet.Existencias.length === 0) {
            HiDialog.Preloader(false);
            HiNotification.Alert('El número de serie indicado no está en existencias.', this.$t('common.error'));
            return;
          }
          this.establishedPallet(palet);
          HiDialog.Preloader(false);
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch(() => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
        });
    },
    async update() {
      this.preloader = true;
      this.lstElaborateArticles = await this.Conexion_ObtainElaboratedArticlesXSerialNumber(this.objAnsSelected);
      this.preloader = false;
    },
    async eventReadElaboratedArticle(value) {
      Log(this, this.eventReadPalet.name);
      this.preloader = true;
      await this.Conexion_AssociateElaboratedArticleWithPale(this.objAnsSelected, [value]);
      this.lstElaborateArticles = await this.Conexion_ObtainElaboratedArticlesXSerialNumber(this.objAnsSelected);
      this.preloader = false;
    },
    getPartsArticleElaborated(objArt) {
      Log(this, this.getPartsArticleElaborated.name);
      let stringSeriesNumbers = '';
      objArt.DatosPartidaOrigen.forEach((dpo) => {
        stringSeriesNumbers += `${dpo.ArticuloPartida.Partida.Serie}/${dpo.ArticuloPartida.Partida.Numero}, `;
      });
      stringSeriesNumbers = stringSeriesNumbers.slice(0, -2);
      return `P. Origen: ${stringSeriesNumbers}`;
    },
    getWorkersArticleElaborated(objArt) {
      Log(this, this.getWorkersArticleElaborated.name);
      let codWorders = '';
      objArt.Trabajadores.forEach((worker) => {
        const nameWorker = worker.Sujeto.NombreCompleto;
        // Utilizar una expresión regular para encontrar el primer grupo de letras
        const firstIndex = nameWorker.search(/[a-z]/i);
        // Utilizar una expresión regular para encontrar el último grupo de letras
        const lastIndex = nameWorker.search(/[a-z](?=\s*$)/i);
        // Obtener el nombre utilizando los índices encontrados
        const name = nameWorker.substring(firstIndex, lastIndex + 1);
        codWorders += `${name}(${worker.Codigo}), `;
      });
      codWorders = codWorders.slice(0, -2);
      if (codWorders.length > 0) {
        return `Trabajadores : ${codWorders}`;
      }
      return codWorders;
    },
    async getPartsANS(idObjAns) {
      Log(this, this.getPartsANS.name);
      let stringSeriesNumbers = '';
      const result = await callExecuteSPERP(
        'APPERPAGRO_PartidasXArticuloNumeroSerie',
        [{ NombreParametro: 'idArticuloNumeroSerie', Valor: idObjAns }],
        'PartidaJSON',
      );
      if (result.status !== 200) {
        HiNotification.Toast('No se han podido obtener las partidas del palé');
        return null;
      }
      result.data.forEach((partida) => {
        stringSeriesNumbers += `${partida.Serie}/${partida.Numero}, `;
      });
      stringSeriesNumbers = stringSeriesNumbers.slice(0, -2);
      return `P. Origen: ${stringSeriesNumbers}`;
    },
    EventOpenSetting() {
      Log(this, this.EventOpenSetting.name);
    },

    async Conexion_ObtainElaboratedArticlesXSerialNumber(objAns) {
      Log(this, this.Conexion_ObtainElaboratedArticlesXSerialNumber.name);
      try {
        const result = await ConexionTA.callObtenerArticulosElaboradosXNumeroSerie(objAns.Id);
        if (result.Valor) {
          return JSON.parse(result.Mensaje);
        }
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      } catch {
        HiNotification.Toast(this.$t('common.checkYourConnection'));
      }
      return [];
    },
    async Conexion_AssociateElaboratedArticleWithPale(objAns, lstCodesElaboratedArticles) {
      Log(this, this.Conexion_AssociateElaboratedArticleWithPale.name);
      try {
        const result = await ConexionTA.callAsociarArticuloElaboradoConPale(objAns.Id, true, JSON.stringify(lstCodesElaboratedArticles));
        if (result.Valor) {
          return result;
        }
        // HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        notifyReadingError(result.Mensaje);
      } catch {
        notifyReadingError(this.$t('common.checkYourConnection'));
        return false;
      }
      return false;
    },
    async Conexion_RemoveAssociationArticleElaboratedWithPale(codeArticle) {
      Log(this, this.Conexion_RemoveAssociationArticleElaboratedWithPale.name);
      try {
        const result = await ConexionTA.callEliminarAsociacionArticuloElaboradoConPaleActulizandoDatosOrigen(codeArticle);
        if (result.Valor) {
          return true;
        }
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      } catch {
        HiNotification.Toast(this.$t('common.checkYourConnection'));
      }
      return false;
    },
  },
};
</script>

<style  lang="scss">
.main-frm-box-reading {
  .page-content {
    overflow: hidden;
  }

  .container-elaborated-items {
    &__title {
      color: #24253d;
      text-transform: none;
      font-size: 22px;
      background: var(--his-tierra-white);
      padding-left: 25px;
      border-bottom: 4px;
      border-top: 0;
      border-right: 0;
      border-left: 0;
      border-color: var(--his-disabled);
      border-style: solid;
    }

    &__list {
      overflow-y: scroll;
      height: 65vh;
    }

    &__item {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      padding-left: 25px;
      border-bottom: 1px;
      border-top: 0;
      border-right: 0;
      border-left: 0;
      border-color: var(--his-disabled);
      border-style: solid;
    }
  }

  .div-configuracionRegistroCajas-cabeceraFormulario {
    margin-left: 22px;
    margin-top: 10px;
    width: 100%;
    max-height: 100%;
    height: 54vh;
    overflow-y: auto;
  }

  .content-subtitle {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 2px;
    flex-direction: column;

    &__strong {
      color: var(--his-steel-blue);
      background-color: var(--his-silver);
      padding: 2px 7px;
      border-radius: 3px;
      font-weight: 500;
      font-size: 16px;
    }

    &__gray {
      font-size: 16px;
      color: #9e9fa3;
      font-weight: 400;
    }
  }

  /* Permite que el boton flotante de Confirmar  este flotante sin desplazamiento */
  .md .fab[class*="-bottom"] {
    position: fixed;
  }

  .container-pale {
    padding-top: 10px;
    padding-left: 25px;
    padding-bottom: 15px;
    background: var(--his-tierra-white);

    &__title {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      padding-right: 20px;
    }
  }
}
</style>
